(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[446],{

/***/ 6133:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categorias/[categoria]",
      function () {
        return __webpack_require__(7459);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ Alert; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var hooks_useComponentsTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9863);


const Alert = (param)=>{
    let { children , ...props } = param;
    const { Alert: AlertTheme  } = (0,hooks_useComponentsTheme__WEBPACK_IMPORTED_MODULE_1__/* .useComponentsTheme */ .U)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AlertTheme, {
        ...props,
        children: children
    });
};


/***/ }),

/***/ 3405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Body; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var hooks_useComponentsTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9863);


const Body = (param)=>{
    let { children , ...props } = param;
    const { Body: BodyTheme  } = (0,hooks_useComponentsTheme__WEBPACK_IMPORTED_MODULE_1__/* .useComponentsTheme */ .U)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BodyTheme, {
        ...props,
        children: children
    });
};


/***/ }),

/***/ 8949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ ProductsList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var hooks_useToast__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1930);
/* harmony import */ var hooks_useSiteSettings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1371);
/* harmony import */ var hooks_useComponentsTheme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9863);
/* harmony import */ var hooks_useBag__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(760);







const ProductsList = (param)=>{
    let { children , ...props } = param;
    var ref;
    const { ProductsList: ProductsListTheme  } = (0,hooks_useComponentsTheme__WEBPACK_IMPORTED_MODULE_5__/* .useComponentsTheme */ .U)();
    const { storeSettings  } = (0,hooks_useSiteSettings__WEBPACK_IMPORTED_MODULE_4__/* .useSiteSettings */ .h)();
    const { openToast  } = (0,hooks_useToast__WEBPACK_IMPORTED_MODULE_3__/* .useToast */ .p)();
    const observer = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { addProductInCart , cart  } = (0,hooks_useBag__WEBPACK_IMPORTED_MODULE_6__/* .useBag */ .c)();
    const handleClickProduct = (product)=>{
        router.push("/produtos/".concat(product.tag));
    };
    const handleClickAddCart = (product, quantity)=>{
        try {
            addProductInCart(product, quantity);
        } catch (e) {
            openToast("Ops, houve um erro ao adicionar o produto no carrinho.");
        }
    };
    const quantityInBag = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((product)=>{
        const productInCart = cart === null || cart === void 0 ? void 0 : cart.items.find((item)=>{
            var ref;
            return ((ref = item.product) === null || ref === void 0 ? void 0 : ref._id) === product._id;
        });
        return (productInCart === null || productInCart === void 0 ? void 0 : productInCart.quantity) || 0;
    }, [
        cart
    ]);
    const lastProductElementRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((node)=>{
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver((entries)=>{
            if (entries[0].isIntersecting && props.hasMore) {
                props.setPage((prevPage)=>prevPage + 1);
            }
        });
        if (node) observer.current.observe(node);
    }, [
        props.hasMore,
        props.setPage
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductsListTheme, {
        ...props,
        onClickProduct: handleClickProduct,
        onClickAddCart: handleClickAddCart,
        quantityInBag: quantityInBag,
        informQuantityAtProductCard: storeSettings === null || storeSettings === void 0 ? void 0 : (ref = storeSettings.theme) === null || ref === void 0 ? void 0 : ref.informQuantityAtProductCard,
        lastProductRef: lastProductElementRef,
        children: children
    });
};


/***/ }),

/***/ 120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ TitleWithSort; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var hooks_useComponentsTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9863);


const TitleWithSort = (param)=>{
    let { children , ...props } = param;
    const { TitleWithSort: TitleWithSortTheme  } = (0,hooks_useComponentsTheme__WEBPACK_IMPORTED_MODULE_1__/* .useComponentsTheme */ .U)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TitleWithSortTheme, {
        ...props,
        children: children
    });
};


/***/ }),

/***/ 3530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ useProductsFilters; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/swr/esm/index.js + 9 modules
var esm = __webpack_require__(2515);
// EXTERNAL MODULE: ./src/services/api/index.ts
var services_api = __webpack_require__(9484);
;// CONCATENATED MODULE: ./src/services/api/productService.ts
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ 
async function getProducts(config) {
    const { hostname , categories , search , sortBy , brand , attributes  } = config || {};
    const response = await api.get("/products", {
        params: {
            status: "active",
            search,
            categories,
            sortBy,
            shouldGroupVariations: true,
            brand,
            showBrand: true,
            attributes
        },
        ...hostname ? {
            headers: {
                "x-domain": hostname
            }
        } : {}
    });
    return response.data;
}
async function getProductsFilters(config) {
    const { hostname , categories , search  } = config || {};
    const response = await services_api/* api.get */.h.get("/products/filters", {
        params: {
            status: "active",
            search,
            categories
        },
        ...hostname ? {
            headers: {
                "x-domain": hostname
            }
        } : {}
    });
    return response.data;
}
async function getProductByTag(config) {
    const { hostname , tag  } = config;
    const response = await api.get("/products/tag/".concat(tag), {
        params: {
            status: "active",
            shouldGroupVariations: true
        },
        ...hostname ? {
            headers: {
                "x-domain": hostname
            }
        } : {}
    });
    return response.data;
}

;// CONCATENATED MODULE: ./src/hooks/useProductsFilters.tsx




function useProductsFilters(props) {
    const { params  } = props || {};
    const [selectedFilters, setSelectedFilters] = (0,react.useState)({});
    const { data , error  } = (0,esm/* default */.ZP)("products-filters".concat(lib_default().stringify(params)), ()=>getProductsFilters(params));
    const filters = (0,react.useMemo)(()=>data || [], [
        data
    ]);
    const selectFilter = (0,react.useCallback)((id, optionId)=>{
        setSelectedFilters((prevState)=>{
            var ref;
            const alreadyIsSelected = prevState === null || prevState === void 0 ? void 0 : (ref = prevState[id]) === null || ref === void 0 ? void 0 : ref.includes(optionId);
            if (alreadyIsSelected) {
                return {
                    ...prevState,
                    [id]: prevState[id].filter((option)=>option !== optionId)
                };
            }
            return {
                ...prevState,
                [id]: [
                    ...prevState[id] || [],
                    optionId
                ]
            };
        });
    }, []);
    return {
        filters,
        isLoading: !data && !error,
        selectedFilters,
        selectFilter
    };
}


/***/ }),

/***/ 8786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ useProductsPaginated; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var services_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9484);



function useProductsPaginated(props) {
    const [productsData, setProductsData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [hasMore, setHasMore] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const [options, setOptions] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        page: 0,
        categories: "",
        sortBy: "",
        search: "",
        brand: "",
        attributes: ""
    });
    const [page, setPage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1);
    const [isLoading, setIsLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { params  } = props || {};
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setOptions((previous)=>{
            if (page === previous.page) {
                setProductsData([]);
                setHasMore(true);
                setPage(1);
            }
            return {
                page: page === previous.page ? 1 : page,
                categories: params.categories,
                sortBy: params.sortBy,
                search: params.search,
                brand: params.brand,
                attributes: params.attributes,
                status: "active",
                showBrand: true,
                shouldGroupVariations: true
            };
        });
    }, [
        params.categories,
        params.sortBy,
        page,
        params.search,
        params.brand,
        params.attributes
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (async function() {
            let limit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 18;
            try {
                if (!hasMore || options.page === 0) {
                    return;
                }
                if (page === 1) {
                    setIsLoading(true);
                }
                const { data: response  } = await services_api__WEBPACK_IMPORTED_MODULE_2__/* .api.get */ .h.get("products/paginated?".concat(qs__WEBPACK_IMPORTED_MODULE_0___default().stringify(options)));
                if (response.length !== 0) {
                    setProductsData((prev)=>[
                            ...prev,
                            ...response
                        ]);
                }
                setHasMore(response.length !== 0);
                if (page === 1) {
                    setIsLoading(false);
                }
            } catch (err) {
                console.error(err);
            }
        })();
    }, [
        options.page,
        options.categories,
        options.sortBy,
        options.search,
        options.brand
    ]);
    return {
        productsData,
        hasMore,
        setPage,
        isLoading
    };
}



/***/ }),

/***/ 7459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/themes/default/components/LayoutFilter/index.tsx + 1 modules
var LayoutFilter = __webpack_require__(2913);
// EXTERNAL MODULE: ./src/hooks/useSiteSettings.tsx + 1 modules
var useSiteSettings = __webpack_require__(1371);
// EXTERNAL MODULE: ./src/hooks/useProductsFilters.tsx + 1 modules
var useProductsFilters = __webpack_require__(3530);
// EXTERNAL MODULE: ./src/utils/formatAttributesFilters.ts
var formatAttributesFilters = __webpack_require__(326);
// EXTERNAL MODULE: ./src/components/TitleWithSort/index.tsx
var TitleWithSort = __webpack_require__(120);
// EXTERNAL MODULE: ./src/components/ProductsList/index.tsx
var ProductsList = __webpack_require__(8949);
// EXTERNAL MODULE: ./src/components/Body/index.tsx
var Body = __webpack_require__(3405);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./src/components/BannerCategory/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 190px;\n  width: 100%;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  min-width: 100%;\n  object-position: center;\n  object-fit: cover;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  bottom: 0;\n  background-color: transparent;\n\n  & li {\n    margin: 0 ",
        ";\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  height: ",
        ";\n  width: ",
        ";\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}

const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-277509f2-0"
})(_templateObject(), (p)=>p.theme.colors.border);
const Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-277509f2-1"
})(_templateObject1());
const WrapperDots = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-277509f2-2"
})(_templateObject2(), (p)=>p.theme.spacing.small);
const Dots = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-277509f2-3"
})(_templateObject3(), (p)=>p.theme.colors.background, (p)=>p.theme.spacing.nano, (p)=>p.theme.spacing.large);

;// CONCATENATED MODULE: ./src/components/BannerCategory/index.tsx


const BannerCategory = (param)=>{
    let { banners  } = param;
    if (!banners) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
            src: banners.desktop,
            alt: "Category banner"
        })
    });
};

// EXTERNAL MODULE: ./src/components/Alert/index.tsx
var Alert = __webpack_require__(5539);
// EXTERNAL MODULE: ./src/hooks/useProductsPaginated.ts
var useProductsPaginated = __webpack_require__(8786);
;// CONCATENATED MODULE: ./src/pages/categorias/[categoria]/index.page.tsx













const Category = ()=>{
    var ref, ref1;
    const router = (0,next_router.useRouter)();
    const [sortBy, setSortBy] = (0,react.useState)();
    const { categories  } = (0,useSiteSettings/* useSiteSettings */.h)();
    const { query  } = router;
    const categoriesFound = (0,react.useMemo)(()=>{
        var ref, ref1;
        let subcategory;
        const category = categories === null || categories === void 0 ? void 0 : categories.find((cat)=>{
            var ref;
            return cat.tag === (query === null || query === void 0 ? void 0 : query.categoria) || ((ref = cat.subcategories) === null || ref === void 0 ? void 0 : ref.find((subcat)=>{
                return subcat.tag === (query === null || query === void 0 ? void 0 : query.categoria);
            }));
        });
        if ((category === null || category === void 0 ? void 0 : category.tag) !== (query === null || query === void 0 ? void 0 : query.categoria)) subcategory = category === null || category === void 0 ? void 0 : (ref = category.subcategories) === null || ref === void 0 ? void 0 : ref.find((subcat)=>{
            return subcat.tag === (query === null || query === void 0 ? void 0 : query.categoria);
        });
        if (subcategory) return {
            category: subcategory,
            categoriesId: subcategory._id
        };
        return {
            category,
            categoriesId: [
                category === null || category === void 0 ? void 0 : category._id,
                ...(category === null || category === void 0 ? void 0 : (ref1 = category.subcategories) === null || ref1 === void 0 ? void 0 : ref1.map((sub)=>sub._id)) || []
            ].join("|")
        };
    }, [
        categories,
        query
    ]);
    const { filters: productsFilters , selectedFilters , selectFilter  } = (0,useProductsFilters/* useProductsFilters */._)({
        params: {
            categories: categoriesFound.categoriesId
        }
    });
    const formattedAttributesFilters = (0,react.useMemo)(()=>(0,formatAttributesFilters/* formatAttributesFilters */.v)(selectedFilters), [
        selectedFilters
    ]);
    const { productsData , hasMore , setPage , isLoading  } = (0,useProductsPaginated/* useProductsPaginated */.e)({
        params: {
            categories: categoriesFound.categoriesId,
            sortBy,
            attributes: formattedAttributesFilters
        }
    });
    const handleChangeSortBy = (sortSelected)=>{
        if (sortSelected) {
            setSortBy(sortSelected);
        } else {
            setSortBy(undefined);
        }
    };
    const quantityProducts = (productsData === null || productsData === void 0 ? void 0 : productsData.length) || 0;
    const categoriesOptions = (0,react.useMemo)(()=>{
        return categories === null || categories === void 0 ? void 0 : categories.filter((cat)=>{
            var ref;
            return cat._id !== ((ref = categoriesFound.category) === null || ref === void 0 ? void 0 : ref._id);
        }).map((cat)=>({
                title: cat.name,
                href: "/categorias/".concat(cat.tag)
            }));
    }, [
        categories,
        categoriesFound
    ]);
    const subCategoriesOptions = (0,react.useMemo)(()=>{
        var ref, ref1;
        return (ref = categoriesFound.category) === null || ref === void 0 ? void 0 : (ref1 = ref.subcategories) === null || ref1 === void 0 ? void 0 : ref1.map((sub)=>({
                title: sub.name,
                href: "/categorias/".concat(sub.tag)
            }));
    }, [
        categoriesFound
    ]);
    const formattedFilters = (0,react.useMemo)(()=>{
        const filters = (categoriesOptions === null || categoriesOptions === void 0 ? void 0 : categoriesOptions.length) || (subCategoriesOptions === null || subCategoriesOptions === void 0 ? void 0 : subCategoriesOptions.length) ? [
            {
                title: "Subcategorias",
                items: subCategoriesOptions
            },
            {
                title: "Categorias",
                items: categoriesOptions
            }
        ] : [];
        productsFilters.forEach((productsFilter)=>{
            filters.push({
                title: productsFilter.label,
                items: productsFilter.options.map((option)=>{
                    var ref;
                    return {
                        title: option.label,
                        onClick: ()=>selectFilter(productsFilter._id, option._id),
                        isSelected: selectedFilters === null || selectedFilters === void 0 ? void 0 : (ref = selectedFilters[productsFilter._id]) === null || ref === void 0 ? void 0 : ref.includes(option._id)
                    };
                })
            });
        });
        return filters;
    }, [
        categoriesOptions,
        productsFilters,
        selectFilter,
        selectedFilters,
        subCategoriesOptions
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerCategory, {
                banners: (ref = categoriesFound.category) === null || ref === void 0 ? void 0 : ref.banners
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Body/* Body */.u, {
                hasSpacingY: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleWithSort/* TitleWithSort */.M, {
                        title: ((ref1 = categoriesFound.category) === null || ref1 === void 0 ? void 0 : ref1.name) || "",
                        onChangeSortBy: handleChangeSortBy,
                        subtitle: quantityProducts === 1 ? "1 produto" : "".concat(quantityProducts, " produtos")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LayoutFilter/* default */.Z, {
                        filters: formattedFilters,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsList/* ProductsList */.R, {
                                products: productsData,
                                shimmerEffectQuantity: 6,
                                isLoading: isLoading,
                                initialColumnItemsCount: 3,
                                setPage: setPage,
                                hasMore: hasMore
                            }),
                            productsData && !productsData.length && !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* Alert */.b, {
                                color: "warning",
                                children: "N\xe3o existem produtos cadastrados nessa categoria."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var index_page = (Category);


/***/ }),

/***/ 8927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ Collapse; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./src/themes/default/components/Collapse/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 0;\n  opacity: 0;\n  overflow: hidden;\n\n  transition: height 0.3s ease, opacity 0.3s ease-in;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-21205f59-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/themes/default/components/Collapse/index.tsx



const Collapse = (param)=>{
    let { isOpen =false , children  } = param;
    const containerRef = (0,react.useRef)(null);
    const contentRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        if (!containerRef.current || !contentRef.current) return;
        if (isOpen) {
            containerRef.current.style.height = "".concat(contentRef.current.clientHeight, "px");
            containerRef.current.style.opacity = "1";
        } else {
            containerRef.current.style.height = "0px";
            containerRef.current.style.opacity = "0";
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        ref: containerRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: contentRef,
            children: children
        })
    });
};


/***/ }),

/***/ 2913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_LayoutFilter; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(6893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/themes/default/components/Collapse/index.tsx + 1 modules
var Collapse = __webpack_require__(8927);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./src/themes/default/components/LayoutFilter/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  gap: ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  font-size: ",
        ";\n  flex-shrink: 0;\n\n  @media (max-width: 768px) {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  width: 100%;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  border-bottom: 1px solid ",
        ";\n\n  padding: ",
        " 0;\n\n  width: 200px;\n\n  &:first-child {\n    padding-top: 0;\n  }\n\n  &:last-child {\n    padding-bottom: 0;\n    border-bottom: none;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: ",
        ";\n  color: ",
        ";\n\n  transition: opacity 0.4s;\n  will-change: opacity;\n\n  &:hover {\n    opacity: 0.6;\n  }\n\n  svg {\n    width: ",
        ";\n    height: ",
        ";\n    stroke-width: 3;\n\n    transition: transform 0.3s;\n    will-change: transform;\n    transform: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: bold;\n  text-transform: uppercase;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n  gap: ",
        ";\n\n  cursor: pointer;\n  font-weight: 300;\n\n  transition: opacity 0.3s;\n  will-change: opacity;\n\n  &:hover {\n    opacity: 0.5;\n  }\n\n  > input {\n    cursor: pointer;\n    width: 10px;\n    height: 10px;\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}

const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e669d1cf-0"
})(_templateObject(), (p)=>p.theme.spacing.xLarge);
const WrapperFilter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e669d1cf-1"
})(_templateObject1(), (p)=>p.theme.font.small);
const WrapperContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e669d1cf-2"
})(_templateObject2());
const SectionFilter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e669d1cf-3"
})(_templateObject3(), (p)=>p.theme.spacing.small, (p)=>p.theme.colors.border, (p)=>p.theme.spacing.medium);
const HeaderSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e669d1cf-4"
})(_templateObject4(), (p)=>p.theme.spacing.small, (p)=>p.theme.colors.primary, (p)=>p.theme.font.large, (p)=>p.theme.font.large, (p)=>p.isItemsVisible ? "rotate(180deg)" : "rotate(0deg)");
const Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e669d1cf-5"
})(_templateObject5());
const Option = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e669d1cf-6"
})(_templateObject6(), (p)=>p.theme.spacing.small);
const WrapperOptions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e669d1cf-7"
})(_templateObject7(), (p)=>p.theme.spacing.small);

;// CONCATENATED MODULE: ./src/themes/default/components/LayoutFilter/index.tsx






const LayoutFilter = (param)=>{
    let { children , filters  } = param;
    const [filtersHidden, setFiltersHidden] = (0,react.useState)();
    const handleHiddenFilter = (title)=>{
        if (filtersHidden === null || filtersHidden === void 0 ? void 0 : filtersHidden.find((filter)=>filter === title)) {
            setFiltersHidden((prev)=>{
                return [
                    ...(prev === null || prev === void 0 ? void 0 : prev.filter((prevTitle)=>prevTitle !== title)) || []
                ];
            });
        } else {
            setFiltersHidden((prev)=>[
                    ...prev || [],
                    title
                ]);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            !!filters.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperFilter, {
                children: filters === null || filters === void 0 ? void 0 : filters.map((filter)=>{
                    var ref, ref1;
                    const itemsLength = (filter === null || filter === void 0 ? void 0 : (ref = filter.items) === null || ref === void 0 ? void 0 : ref.length) || 0;
                    if (!itemsLength) return null;
                    const isHidden = filtersHidden === null || filtersHidden === void 0 ? void 0 : filtersHidden.find((f)=>f === filter.title);
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionFilter, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSection, {
                                isItemsVisible: !isHidden,
                                onClick: ()=>handleHiddenFilter(filter.title),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                        children: filter.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiChevronUp */.rH8, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* Collapse */.U, {
                                isOpen: !isHidden,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperOptions, {
                                    children: filter === null || filter === void 0 ? void 0 : (ref1 = filter.items) === null || ref1 === void 0 ? void 0 : ref1.map((item)=>{
                                        return item.onClick ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Option, {
                                            as: "label",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: item.isSelected,
                                                    onChange: ()=>{
                                                        var ref;
                                                        return (ref = item.onClick) === null || ref === void 0 ? void 0 : ref.call(item);
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: item.title
                                                })
                                            ]
                                        }, item.title) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: item.href || "#",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Option, {
                                                children: [
                                                    "- ",
                                                    item.title
                                                ]
                                            })
                                        }, item.title);
                                    })
                                })
                            })
                        ]
                    }, filter.title);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperContent, {
                children: children
            })
        ]
    });
};
/* harmony default export */ var components_LayoutFilter = (LayoutFilter);


/***/ }),

/***/ 326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ formatAttributesFilters; }
/* harmony export */ });
function formatAttributesFilters(filters) {
    if (Object.values(filters || {}).length === 0) return undefined;
    return Object.entries(filters).reduce((acc, selectedFilter)=>{
        const [id, optionIds] = selectedFilter;
        if ((optionIds || []).length === 0) return acc;
        const formattedAttributeFilter = "".concat(id, "=").concat(optionIds.join("|"));
        return "".concat(acc).concat(acc ? "," : "").concat(formattedAttributeFilter);
    }, "");
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [893,664,515,774,888,179], function() { return __webpack_exec__(6133); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);